export const ZALANDO_FASHION_STORE_RETAILERID =
  '810d1d00-4312-43e5-bd31-d8373fdd24c7';
